export const discountCategory = {
	title: "Categorias de Descontos",
	label: "Crie, edite, delete, ative ou desative categorias de desconto",
	search: {
		label: "Pesquisar",
		placeholder: "Pesquisar nome da categoria de desconto",
	},
	filter: {
		label: "Filtrar por",
		placeholder: "Escolher filtro",
	},
	create: "Criar nova categoria",
	allCategories: "Todas as categorias de desconto",
	activeCategories: "Categorias de desconto ativas",
	inactiveCategories: "Categorias de desconto inativas",
	errorNotification: "Selecione um local primeiro",
	drawer: {
		edit: "Editar categoria de desconto",
		create: "Criar categoria de desconto",
	},
	form: {
		name: {
			label: "Nome da categoria",
			placeholder: "Dê um nome à categoria de desconto",
		},
		discount: {
			label: "Desconto dado em",
			value: "Reais",
			percentage: "Porcentagem",
		},
		estabilishedType: {
			label: "Estabelecido",
			fixed: "Valor fixo",
			range: "Faixa",
		},
		employees: {
			label: "Funcionários autorizados a utilizar a categoria",
			placeholder: "Pesquise por nome",
		},
		between: "Entre",
		and: "e",
		errors: {
			name: "Insira um nome válido",
			estabilishedType: "Selecione uma opção acima",
			employees: "Selecione um funcionário",
		},
		observation: "Observações",
		addObservation: "Permitir adicionar observação",
	},
	modal: {
		title: "Excluir categoria de desconto",
		message: "Você deseja excluir a categoria de '{{name}}'?",
	},
	table: {
		status: "STATUS",
		name: "NOME DA CATEGORIA DE DESCONTO",
		discountType: "DESCONTO DADO EM",
		value: "FAIXA OU VALOR FIXO",
		showEmployees: "Visualizar funcionários com permissão",
		hideEmployees: "Ocultar funcionários com permissão",
		emptyText: "Parece que você ainda não criou uma categoria de desconto",
		editCategory: "Editar categoria de desconto",
		removeCategory: "Excluir categoria de desconto",
		employee: "Funcionário com Permissão",
		loading: "Carregando",
	},
};
